module.exports = __webpack_public_path__ + "static/bg01-bfc4e4f304c5e9b8b17557f0219159f5.jpg";